<template>
	<div>
		<div v-if="done">
			<b-container fluid>
				<b-form @submit="onSubmit">
					<input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id" />
<b-form-group label="Code">
      <b-form-input
          type="text"
          id="dataItem-code-input"
          class="form-input"
          v-model="dataItem.code"
          @blur="$v.dataItem.code.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.code.required">Code is required</div>
      </div>
      </b-form-group>
<b-form-group label="Description">
      <b-form-input
          type="text"
          id="dataItem-description-input"
          class="form-input"
          v-model="dataItem.description"
          @blur="$v.dataItem.description.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.description.required">Description is required</div>
      </div>
      </b-form-group>
<b-form-group label="Active">
  <b-form-checkbox
    id="dataItem-active-input"
    class="form-input"
    v-model="dataItem.active">Active
    </b-form-checkbox>
  </b-form-group>

					<b-button
						type="submit"
						variant="primary"
						style="margin: 5px;"
					>Save</b-button>
					<b-button
						style="margin: 5px;"
						@click="cancel"
					>Cancel</b-button>
				</b-form>
			</b-container>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import service from '../../service';
import { dataItemDto } from '../../dto';

export default {
  name: 'edit',
  data: () => ({
    done: false,
    dataItem: null,
  	}),
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    getRecord() {
      this.done=false;
      service.getById(this.id).then(data => {
        this.dataItem = data;
        this.done=true;
      });
    },
    async onSubmit(e) {
      e.preventDefault();

      this.$v.dataItem.$touch();
      if (this.$v.dataItem.$invalid) {
        return;
      }

      let payload = new dataItemDto(this.dataItem);

      try {
        const id = await service.update(payload);
        this.redirectToListing();
      } catch {}
    },
    cancel(){
      this.redirectToListing();
    },
    redirectToListing() {
      this.$router.push({ name: 'ncmcodes' });
    },
  },
  mounted() {
    this.getRecord(this.id);
  },
  validations:{
    dataItem:{

      id:{
      },
      code:{
      },
      description:{
      },
      createdByUserId:{
      },
      modifiedByUserId:{
      },
      dateCreated:{
      },
      dateModified:{
      },
      active:{
      },
    },
  },
}
</script>
